<template>
  <div>
    <div class="panel">
      <div class="icon-wrapper">
        <svg-icon :icon-class="icon" :color="color" size="48"/>
      </div>
      <div class="desc">
        <div class="text">{{ title }}</div>
        <count-to :start-val="0" :end-val="val" :duration="dura" class="num"/>
      </div>
    </div>
  </div>
</template>

<script>
import CountTo from 'vue-count-to'


export default {
  name: 'Counter',
  components: {
    CountTo
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    val: {
      type: Number,
      default: 0
    },
    dura: {
      type: Number,
      default: 3000 + Math.floor(Math.random() * 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.panel {
	height: 108px;
	font-size: 12px;
	position: relative;
	overflow: hidden;
	color: #666;
	background: #fff;
	box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
	border-color: rgba(0, 0, 0, .05);

	.icon-wrapper {
		float: left;
		margin: 14px 0 0 14px;
		padding: 16px;
		transition: all 0.38s ease-out;
		border-radius: 6px;
	}

  .desc {
    float: right;
    font-weight: bold;
    margin: 26px;
    margin-left: 0px;
    .text {
      line-height: 18px;
      color: rgba(0, 0, 0, 0.45);
      font-size: 16px;
      margin-bottom: 12px;
    }
    .num {
      font-size: 20px;
    }
  }
}
</style>

